<template>
  <el-drawer
    v-if="data"
    class="order-detail-drawer"
    :visible="visible"
    :title="$t('text.orderDetail')"
    :show-close="true"
    @close="handleClose"
  >
    <div class="order-detail-drawer-content">
      <div class="detail-title">{{$t("text.orderInfo")}}</div>
      <div class="detail-info">
        <span class="detail-left">{{$t("text.orderStatus")}}</span>
        <OrderStatusTag :status="data.status" />
      </div> 
      <div class="detail-info">
        <span class="detail-left">{{$t("text.orderNumber")}}</span>
        <div class="detail-right">
          <span>{{data.orderId}}</span>
          <i class="el-icon-document-copy"  v-copy="data.orderId"></i>
        </div>
      </div>
      <div class="detail-info">
        <span class="detail-left">{{$t("text.merchantOrderNumber")}}</span>
        <div class="detail-right">
          <span>{{data.merchantOrderId}}</span>
          <i class="el-icon-document-copy" v-copy="data.merchantOrderId"></i>
        </div>
      </div>
      <div class="detail-info">
        <span class="detail-left">{{$t("text.channelOrderNumber")}}</span>
        <div class="detail-right">
          <span>{{data.channelOrderId}}</span>
          <i class="el-icon-document-copy" v-copy="data.channelOrderId"></i>
        </div>
      </div>
      <div class="detail-info">
        <span class="detail-left">{{$t("text.orderAmount")}}</span>
        <div class="detail-right">
          <span>{{ $formatter.FenToYuanToThousandth(null,null,data.amount)}}</span>
          <i class="el-icon-document-copy"></i>
        </div>
      </div>
      <div class="detail-info">
        <span class="detail-left">{{$t('text.fee')}}({{ $t('text.feeRate')}}%)</span>
        <span class="detail-right"> {{data.fee}} {{data.feeRate ? `(${data.feeRate})` : ''}} </span>
      </div>
      <div class="detail-info">
        <span class="detail-left">{{$t('text.realPay')}}</span>
        <span class="detail-right"> {{$formatter.FenToYuanToThousandth(null,null,data.realPayAmount)}} </span>
      </div>
      <div class="detail-info">
        <span class="detail-left">{{$t('text.whetherToCallback')}}</span>
        <span class="detail-right">{{ $formatter.formatCallBackStatus(null,null,data.callbackStatus) }}</span>
      </div>
      <div class="detail-info">
        <span class="detail-left">{{$t('text.whetherToSettle')}}</span>
        <span class="detail-right">{{$formatter.formatSettlementStatus(null,null,data.settlementStatus)}}</span>
      </div>
      <div class="detail-info">
        <span class="detail-left">{{$t('text.settlementCycle')}}</span>
        <span class="detail-right">{{ data.settlementCycle }}</span>
      </div>
    </div>
    <div class="order-detail-drawer-content">
      <div class="detail-title">{{$t("text.merchantInfo")}}</div>
      <div class="detail-info">
        <span class="detail-left">{{ $t('text.agentName')}}</span>
        <span class="detail-right">{{data.agentName}}</span>
      </div>
      <div class="detail-info" v-if="ROLE_TYPE.isManager()">
        <span class="detail-left">{{$t('text.merchantName')}}</span>
        <span class="detail-right">{{data.merchantName}}</span>
      </div>
      <div class="detail-info">
        <span class="detail-left">{{$t('text.paymentChannel')}}</span>
        <span class="detail-right">{{data.channelName}}</span>
      </div>
      <div class="detail-info">
        <span class="detail-left">{{$t("text.upstream")}}</span>
        <span class="detail-right">{{data.providerName}}</span>
      </div>
    </div>
    <div class="order-detail-drawer-content user-info">
      <div class="detail-title">{{ $t("text.userInfo") }}</div> 
        <div class="detail-info">
          <span class="detail-left">{{$t('text.accountNumber')}}</span>
         <div class="detail-right">
          <span>{{data.accountNum}}</span>
          <i class="el-icon-document-copy" v-copy="data.accountNum"></i>
        </div>
        </div>
        <div class="detail-info">
          <span class="detail-left">{{$t('text.phoneNumber')}}</span>
         <div class="detail-right">
          <span>{{data.customerPhone}}</span>
          <i class="el-icon-document-copy" v-copy="data.customerPhone"></i>
        </div>
        </div>
        <div class="detail-info">
          <span class="detail-left">{{$t('text.name')}}</span>
         <div class="detail-right">
          <span>{{data.customerName}}</span>
          <i class="el-icon-document-copy" v-copy="data.customerName"></i>
        </div>
        </div>
        <div class="detail-info">
          <span class="detail-left">{{$t('text.customerCert')}}</span>
         <div class="detail-right">
          <span>{{data.customerCert}}</span>
          <i class="el-icon-document-copy" v-copy="data.customerCert"></i>
        </div>
        </div>
      </div>

  </el-drawer>
</template>
<script>
import OrderStatusTag from "./OrderStatusTag.vue"
import { ROLE_TYPE } from "@/utils/Constant";
export default {
    components: {
        OrderStatusTag 
    },
  props: {
    data: {
      type: Object,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE;
    },
  },
  methods: {
    handleClose() {
      this.$emit('update:data', null); 
      this.$emit('update:visible', false); 
    },
  },
};
</script>
<style lang="scss" scoped>
.order-detail-drawer {
  ::v-deep .el-drawer {
    width: 450px !important;
    .el-drawer__body {
      padding: 0 20px;
    }
  }
  .order-detail-drawer-content {
    font-size: 14px;
    margin-bottom: 16px;
    .detail-title {
      font-weight: 600;
      font-size: 18px;
      line-height: 26px;
    }
    .detail-info {
      display: flex;
      align-items: center;
      height: 46px;
      gap: 1px;
      .detail-left {
        display: block;
        width: 93px;
        color: rgba(96, 98, 102, 1);
      }
      .detail-right {
        display: flex;
        gap: 4px;
        align-items: center;
        .el-icon-document-copy {
            cursor: pointer;
        }
      }
    }
  }
}
</style>
